import { Drawer, makeStyles } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import React, { useMemo } from 'react';
import ErrorDrawer from '~/modules/tasks/components/TaskDrawer/ErrorDrawer';
import LoadingDrawer from '~/modules/tasks/components/TaskDrawer/LoadingDrawer';
import {
  useIsPtiEnabled,
  useSkillLevels,
  useFetchRequisitionData
} from '~/modules/common/hooks';
import { useMeContext } from '~/modules/me';
import { useResourceRequestDetails } from '~/modules/resourcing/common/hooks';
import { ResourceRequestDrawerContent2 } from './ResourceRequestDrawerContent/ResourceRequestDrawerContent';

const useDrawerStyles = makeStyles(theme => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    alignContent: 'flex-start',
    padding: 0,
    width: 580,
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    },
    [theme.breakpoints.up('md')]: {
      width: 700
    }
  }
}));

export const ResourceRequestDrawer = ({
  resourceRequestId,
  onClose,
  allocationChartRef,
  open
}) => {
  const {
    featureFlags: { isPsaRmpTaskAllocation1Enabled }
  } = useMeContext();
  const drawerClasses = useDrawerStyles();

  const modalProps = useMemo(
    () => ({ onBackdropClick: onClose, onEscapeKeyDown: onClose }),
    [onClose]
  );

  const {
    loading,
    projectRequestDetails: {
      resourceRequest,
      resourceAllocations,
      project,
      defaultRequestAttributeWeights
    } = {},
    error: errorData
  } = useResourceRequestDetails(
    resourceRequestId,
    isPsaRmpTaskAllocation1Enabled
  );

  const isPtiEnabled = useIsPtiEnabled();

  const {
    requisition,
    loading: isRequisitionLoading
  } = useFetchRequisitionData({
    resourceRequestUri: resourceRequestId,
    skip: !isPtiEnabled
  });

  const { maxSkillLevel, isSkillLoading } = useSkillLevels();

  return (
    <Drawer
      anchor="right"
      open={open}
      variant="temporary"
      classes={drawerClasses}
      ModalProps={modalProps}
    >
      {isSkillLoading || loading || isRequisitionLoading ? (
        <LoadingDrawer onClose={onClose} />
      ) : errorData && errorData.error ? (
        <ErrorDrawer data={errorData} onClose={onClose} />
      ) : (
        <ResourceRequestDrawerContent2
          onClose={onClose}
          resourceRequest={resourceRequest}
          resourceAllocations={resourceAllocations}
          project={project}
          defaultRequestAttributeWeights={defaultRequestAttributeWeights}
          maxSkillLevel={maxSkillLevel}
          allocationChartRef={allocationChartRef}
          requisition={requisition}
        />
      )}
    </Drawer>
  );
};

ResourceRequestDrawer.propTypes = {
  resourceRequestId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  allocationChartRef: PropTypes.object,
  open: PropTypes.bool
};

export default ResourceRequestDrawer;
